import * as yup from "yup";
import { validationNotEmpty, validationWithoutSpace, } from "./defaultValidations";

export default yup.object({
  policyName: validationWithoutSpace("policyName"),
  charset: validationNotEmpty("Charset"),
  keyName: validationNotEmpty("Mask Char"),
  perSuff: validationNotEmpty("Perserved Suffix Length"),
  perPrefix: validationNotEmpty("Perserved Prefix Length")
});